import { render } from "./QuestionWithTextAnswers.vue?vue&type=template&id=0789995a"
import script from "./QuestionWithTextAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionWithTextAnswers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__